import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

type CopyToClipboardIconProps = {
    textToCopy: string;
    tooltipCopy?: string;
    tooltipCopied?: string;
};

const CopyToClipboard: React.FC<CopyToClipboardIconProps> = ({
    textToCopy,
    tooltipCopy = "Copy",
    tooltipCopied = "Copied!",
}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
        } catch (err) {
            console.error("Failed to copy text:", err);
        }
    };

    return (
        <Tooltip title={copied ? tooltipCopied : tooltipCopy}>
            <IconButton onClick={handleCopy} aria-label="copy">
                {copied ? <CheckIcon color="success" /> : <ContentCopyIcon />}
            </IconButton>
        </Tooltip>
    );
};

export default CopyToClipboard;
